import { render, staticRenderFns } from "./header-notification.vue?vue&type=template&id=e1acc8b2&scoped=true"
import script from "./header-notification.vue?vue&type=script&lang=js"
export * from "./header-notification.vue?vue&type=script&lang=js"
import style0 from "./header-notification.vue?vue&type=style&index=0&id=e1acc8b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1acc8b2",
  null
  
)

export default component.exports